<template>
  <div class="onboarding-static-page-container">
      <OnboardingMenu class="menu" :logo="logoUrl" :languages="languageOptions" :menus="menuOptions"></OnboardingMenu>
      <div class="header">
        <p class="title">{{ $t('onboarding.nestle.nespresso.title') }}</p>
      </div>
      <div class="body">
        <div class="description">
            <p>{{ $t('onboarding.nestle.nespresso.introduction') }}</p>
            <div class="dividing-line"></div>
        </div>
        <div class="video-board">
          <div class="board-body">
            <div class="board-video">
              <div v-show="videos[0].showVideoImage" class="board-video-preview-image" @click="playVideo(0)">
                <img :src="videos[0].img" alt="">
                <img :src="playIcon" class="board-video-play-icon">
              </div>
              <video :ref="videos[0].ref" v-show="!videos[0].showVideoImage" controls>
                <source src="https://static-c.ajinga.com/nestle/Nespresso_Welcome.mp4" type="video/mp4" />
                <!-- <track src="/vue-static/vtt/Nespresso_Welcome_subtitlesEN.vtt" kind="subtitles" srclang="EN" label="EN" default /> -->
              </video>
            </div>
            <div class="board-content">
              <p class="board-title">{{ $t('onboarding.nestle.nespresso.sectionTitle1') }}</p>
            </div>
          </div>
        </div>
        <div class="image-board clear-margin-top" @click="toOutSide('https://www.nestle-nespresso.com/about-us/our-history')">
            <img :src="imgUrl1" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.nespresso.sectionTitle2') }}</p>
            </div>
        </div>
        <div class="image-board flex-derection-row-reverse" @click="toOutSide('https://www.nespresso.com/ch/en/')">
            <img :src="imgUrl2" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.nespresso.sectionTitle3') }}</p>
            </div>
        </div>
        <div class="video-board">
          <div class="board-body">
            <div class="board-video">
              <div v-show="videos[1].showVideoImage" class="board-video-preview-image" @click="playVideo(1)">
                <img :src="videos[1].img" alt="">
                <img :src="playIcon" class="board-video-play-icon">
              </div>
              <video :ref="videos[1].ref" v-show="!videos[1].showVideoImage" controls src="https://static-c.ajinga.com/nestle/Nespresso_PurposeValues.mp4">
              </video>
            </div>
            <div class="board-content">
              <p class="board-title">{{ $t('onboarding.nestle.nespresso.sectionTitle4') }}</p>
            </div>
          </div>
        </div>
        <div class="image-board clear-margin-top" @click="toOutSide('https://static-c.ajinga.com/nestle/Nespresso_Roadmap.pdf')">
            <img :src="imgUrl3" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.nespresso.sectionTitle5') }}</p>
            </div>
        </div>
        <div class="follow">
          <p v-html="$t('onboarding.nestle.followUs')"></p>
          <p>{{ $t('onboarding.nestle.donnotBeShared') }}</p>
        </div>
      </div>
      <Footer></Footer>
  </div>
</template>

<script>
import { onboardingMixin } from '@/components/onboarding/form/mixin.js'
import OnboardingMenu from '@/components/onboarding/form/Menu'
import Footer from '@/components/onboarding/form/Footer'
import { deviceType } from '@/utils/common'

export default {
  mixins: [onboardingMixin],
  components: {
    OnboardingMenu, Footer
  },
  data () {
    const isMobile = deviceType.isMobile
    return {
      imgUrl1: require(isMobile ? '@/assets/image/onboarding/learning/h5/8.jpg' : '@/assets/image/onboarding/learning/pc/8.jpg'),
      imgUrl2: require(isMobile ? '@/assets/image/onboarding/learning/h5/7.jpg' : '@/assets/image/onboarding/learning/pc/7.jpg'),
      imgUrl3: require('@/assets/image/onboarding/learning/pc/9.jpg'),
      videos: [
        {
          img: require(isMobile ? '@/assets/image/onboarding/learning/h5/video-4.jpg' : '@/assets/image/onboarding/learning/pc/video-4.jpg'),
          showVideoImage: true,
          ref: 'ref1'
        },
        {
          img: require(isMobile ? '@/assets/image/onboarding/learning/h5/video-5.jpg' : '@/assets/image/onboarding/learning/pc/video-5.jpg'),
          showVideoImage: true,
          ref: 'ref2'
        }
      ],
      playIcon: require('@/assets/iconfont/icon-play.svg')
    }
  },
  methods: {
    playVideo (index) {
      this.videos[index].showVideoImage = false
      this.$refs[this.videos[index].ref].play()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '@/assets/scss/onboarding-static-page.scss';

.onboarding-static-page-container {
  .header {
    background-image: url('~@/assets/image/onboarding/learning/h5/banner.jpg');
  }
}

/* 中型设备（台式电脑） */
@media (min-width: 769px) {
  .onboarding-static-page-container {
    .header {
      background-image: url('~@/assets/image/onboarding/learning/pc/banner.jpg');
    }
  }
}
</style>
